import ButtonCustom from "../../../../pages/UiElements/ButtonCustom";

interface Props {
  onSubmit: () => void;
  onCancel?: () => void;

  isSubmitting?: boolean;
  isValid?: boolean;
}

const PaymentActions = ({
  onSubmit,
  onCancel,
  isSubmitting = false,
  isValid = true,
}: Props) => {
  return (
    <div className="border-t border-stroke px-6 py-4 dark:border-strokedark">
      
      <div className="flex justify-end gap-3">
        
        {/* 🔹 Cancelar */}
        <ButtonCustom
          text="Cancelar"
          variant="gray"
          onClick={onCancel}
          disabled={isSubmitting}
        />

        {/* 🔹 Submit */}
        <ButtonCustom
          text={isSubmitting ? "Registrando..." : "Registrar Pago"}
          iconKey="check"
          variant="success"
          onClick={onSubmit}
          disabled={!isValid || isSubmitting}
        />
      </div>

    </div>
  );
};

export default PaymentActions;